/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ subject: NonNullable<unknown> }} Rights_Tools_Remove_Subject_LabelInputs */



/**
* | output |
* | --- |
* | "Remove {subject} and all their tool overrides" |
*
* @param {Rights_Tools_Remove_Subject_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_remove_subject_label = /** @type {((inputs: Rights_Tools_Remove_Subject_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Remove_Subject_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.subject} und alle Tool-Ausnahmen entfernen`)
	return /** @type {LocalizedString} */ (`Remove ${i?.subject} and all their tool overrides`)
});